module.exports = __webpack_public_path__ + "media/img/illustrations/error-8487c806a8118a8212df481013f4158e.svg";